import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ErrorResponse } from '@/common/types/errorResponse'
import { handleServerError } from '@/common/utils/handleServerError'
import { useReviewBillingSupplyAuthorization } from '@/features/supplyAuthorizations/hooks/useReviewBillingSupplyAuthorization'
import { RejectBillingSupplyAuthorizationValidationSchema } from '@/features/supplyAuthorizations/schemas/reject.schema'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

interface ApproveSupplyAuthorizationModalProps {
  disabled?: boolean
}

export const ApproveSupplyAuthorizationModal = ({ disabled }: ApproveSupplyAuthorizationModalProps) => {
  const { id } = useParams()
  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false)
  const [baseError, setBaseError] = useState('')

  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ['billingSupplyAuthorizations'] })
    queryClient.invalidateQueries({ queryKey: ['billingSupplyAuthorization', id] })
    setIsOpen(false)
  }

  const onError = (error: ErrorResponse) => {
    handleServerError({ error, setBaseError })
  }

  const { mutate: approveSupplyAuthorization, isPending: approveSupplyAuthorizationIsPending } =
    useReviewBillingSupplyAuthorization({
      supplyAuthorizationId: id,
      review: 'approve',
      onSuccess,
      onError,
    })

  const onSubmit = () => {
    setBaseError('')
    approveSupplyAuthorization({} as RejectBillingSupplyAuthorizationValidationSchema)
  }

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onConfirm={onSubmit}
      Trigger={
        <Button
          type="button"
          className="w-[10.25rem]"
          disabled={disabled}
          operationKlassToCheckPermission="Admin::Billing::SupplyAuthorizations::Approve"
        >
          Aprovar
        </Button>
      }
      triggerDisabled={disabled}
      useCancellableFooter
      confirmButtonClassName="bg-blue-700"
      disabled={approveSupplyAuthorizationIsPending}
      title="Você tem certeza?"
      titleClass="text-2xl font-bold mb-2"
      subtitle="Essa autorização de fornecimento será aprovada."
      body={baseError ? <p className="text-sm text-danger-soft">{baseError}</p> : undefined}
    />
  )
}
